if (!customElements.get('offer-grid-slider')) {
  customElements.define(
    'offer-grid-slider',
    class OfferGridSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderWrapper = this.querySelector('.swiper');
        if (!this.sliderWrapper) {
          return;
        }

        this.sliderInstance = false;
        this.initSlider();
      }

      disconnectedCallback() {
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
        }
      }

      initSlider() {
        const itemsDesktop = parseFloat(this.dataset.itemsDesktop) || 3;
        const itemsMobile = parseFloat(this.dataset.itemsMobile) || 1;
        const loop = this.dataset.loop === 'true';
        const autoplay = this.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5000;

        this.sliderCounter = this.querySelector('.swiper-pagination-counter');
        this.sliderWrapper.querySelector('.swiper-wrapper').classList.remove('f-grid');

        this.sliderOptions = {
          init: false,
          slidesPerView: itemsMobile,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: itemsDesktop,
              spaceBetween: 16,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          speed: 500,
          loop: loop,
          threshold: 2,
        };

        if (autoplay) {
          this.sliderOptions.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false,
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this.sliderWrapper, this.sliderOptions);
        this.sliderInstance.init();

        this.sliderInstance.slider.on('afterInit', this.onSlideAfterInit.bind(this));
        this.sliderInstance.slider.on('realIndexChange', this.onSlideChange.bind(this));

        this.sliderInstance.slider.init();
      }

      onSlideAfterInit(swiper) {
        const { realIndex } = swiper;
        if (this.sliderCounter && swiper.pagination.bullets) {
          this.sliderCounter.querySelector('.swiper-pagination-current').innerText = realIndex + 1;
          this.sliderCounter.querySelector('.swiper-pagination-total').innerText = swiper.pagination.bullets.length;
        }
      }

      onSlideChange(swiper) {
        const { realIndex } = swiper;
        if (this.sliderCounter && swiper.pagination.bullets) {
          this.sliderCounter.querySelector('.swiper-pagination-current').innerText = realIndex + 1;
        }
      }
    }
  );
}